import atomizeLogo from "../images/atomize_mark.svg";
import footerBg from "../images/home_foot_bg.svg";
import xImg from "../images/ximg.svg";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
const DashboardPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate("/app");
    }, 1000);
  }, [navigate]);
  return (
    <div
      className={
        "bg-black h-screen text-white flex flex-col justify-between items-center"
      }
    >
      <div className={"text-end w-full p-4"}>
        <button
          className={
            "text-plusText font-bold border-2 text-[20px] border-borderColor px-[18px] py-[9px] rounded-[16px] shadow-buttonShadow plus-text-shadow"
          }
        >
          PLUS
        </button>
      </div>
      <div className={"h-full w-full flex flex-col justify-center relative"}>
        <div className={"flex flex-row gap-4 items-center justify-center"}>
          <img
            alt={"atomize"}
            src={atomizeLogo}
            className={"sm:w-[100px] w-[50px]"}
          />
          <span className={"sm:text-8xl text-6xl font-bold"}>FoxAcid</span>
        </div>
        <img
          alt={"foot"}
          src={footerBg}
          className={"absolute bottom-0 w-full"}
        />
      </div>
      <div
        className={
          "p-4 flex justify-between gap-4 items-center w-full flex-col sm:flex-col md:flex-row lg:flex-row"
        }
      >
        <div
          className={
            "px-[24px] py-[9px] border border-borderColor rounded-[16px] flex flex-col w-full sm:w-full md:w-auto lg:w-auto"
          }
        >
          <span className={"text-sm text-[#8C8A94] font-medium"}>
            Support and Feedback
          </span>
          <span className={"text-base text-white font-semibold"}>
            contact@atomizedsign.com
          </span>
        </div>
        <div className={"text-white font-semibold"}>
          <span className={"text-[#FF2EE7]"}>PROJECT BY:</span> AKASH TYAGI
        </div>
        <div
          className={
            "px-[24px] py-[9px] border border-borderColor rounded-[16px] flex flex-row gap-2 max-w-full sm:max-w-full md:max-w-[416px] lg:max-w-[416px] w-auto sm:w-full md:w-auto lg:w-auto"
          }
        >
          <img src={xImg} alt={"xImg"} />
          <span className={"text-[#494656] font-semibold"}>
            <span className={"underline text-white cursor-pointer"}>
              Follow us on X
            </span>{" "}
            for product updates, discounts, and announcements.
          </span>
        </div>
      </div>
    </div>
  );
};
export default DashboardPage;
